import {
  getRemoteConfig,
  fetchAndActivate,
  getValue as getRemoteValue,
} from "firebase/remote-config";
import { webApp } from "../../firebase";

class RemoteConfigService {
  constructor() {
    this.remoteConfig = null;
  }

  init() {
    if (!this.remoteConfig) {
      this.remoteConfig = getRemoteConfig(webApp);
    }
  }

  async fetchAndActivateConfig() {
    this.init();
    try {
      await fetchAndActivate(this.remoteConfig);
      console.log("Remote config fetched and activated.");
    } catch (error) {
      console.error("Remote config fetch failed:", error);
    }
  }

  /**
   * Get remote config value as Boolean
   * @param {string} key
   * @returns {boolean}
   */
  getBooleanValue(key) {
    return getRemoteValue(this.remoteConfig, key).asBoolean();
  }

  /**
   * Get remote config value as string
   * @param {string} key
   * @returns {string}
   */
  getValue(key) {
    return getRemoteValue(this.remoteConfig, key).asString();
  }
}

const remoteConfigService = new RemoteConfigService();
export default remoteConfigService;
